import { render, staticRenderFns } from "./ConfiguracaoNotificacaoEmail.vue?vue&type=template&id=31a96a35&scoped=true&"
import script from "./ConfiguracaoNotificacaoEmail.vue?vue&type=script&lang=js&"
export * from "./ConfiguracaoNotificacaoEmail.vue?vue&type=script&lang=js&"
import style0 from "./ConfiguracaoNotificacaoEmail.vue?vue&type=style&index=0&id=31a96a35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a96a35",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/spa/configuracao/ConfiguracaoNotificacaoEmail.vue
// module id = 1167
// module chunks = 28